




































































































































/* eslint-disable @typescript-eslint/camelcase */

import { Component, Vue, Prop } from 'vue-property-decorator'
import { emailRules, exists, url } from '@/util/inputValidation'
import PhoneInput from '@/components/inputs/PhoneInput.vue'
import { contactSales } from '@/services/landing'

import * as UAParser from 'ua-parser-js'

@Component({
  components: {
    PhoneInput
  }
})
export default class ContactForm extends Vue {
  
  isValid = false
  usePhone = false

  form: any = {}

  rules = {
    contactName: [exists('Name required')],
    email: emailRules,
    url: [url],
    description: [exists('Description required')],
  }

  @Prop(String) readonly type!: 'sales' | 'support'
  @Prop(String) readonly color: string | undefined
  @Prop({ default: false }) readonly text!: boolean
  @Prop({ default: false }) readonly filled!: boolean
  @Prop({ default: true }) readonly showManagerContractorFields!: boolean
  @Prop(Object) readonly dataSupplement: object | undefined

  loading = false

  mounted() {
    if (this.dataSupplement) {
      this.form = {
        ...this.form,
        ...this.dataSupplement
      }
    }
    
    if (this.$route.params.description) {
      this.form.description = this.$route.params.description
    }
  }

  get me() {
    return this.$store.getters.me
  }

  async submitForm() {
    this.loading = true 

    let request: any = {...this.form}

    if (this.form.phone) {
      delete request.email
    }
    else {
      delete request.phone
    }

    request = {
      ...request,
      ...UAParser(navigator.userAgent)
    }

    await contactSales(
      this.$store,
      request,
      this.type
    )

    this.loading = false
    this.$emit('submitted')
  }
}
